import { createContext, useContext } from "react";
import { type BillingProviderAdapter } from "@constructorfleet/ui";

export type BillingContextValue = {
  adapter: BillingProviderAdapter;
  billingProvider: string;
};

export const BillingContext = createContext<BillingContextValue | undefined>(undefined);

export function useBilling() {
  const context = useContext(BillingContext);
  if (!context) {
    throw new Error("useBilling must be used within a BillingProvider");
  }
  return context;
}
